import React from 'react';
import styled from 'styled-components';
import { JSONTree, ShouldExpandNodeInitially } from 'react-json-tree';

const theme = {
  base00: 'inherit', // background
  base01: '#383830',
  base02: '#49483e',
  base03: '#fff', // key shadow
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672', // null
  base09: '#0000FF', // number
  base0A: '#f4bf75',
  base0B: '#008000', // string
  base0C: '#a1efe4',
  base0D: '#000', // keys
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

const StyledDiv = styled.div`
  display: inline-flex;
  & > ul {
    display: inline-flex;
  }
  .key-shadow {
    color: #ccc;
  }
`;

interface TrueImpactJSONProps {
  parseObject: object;
  shouldExpend?: ShouldExpandNodeInitially;
}

const TrueImpactJSON: React.FC<TrueImpactJSONProps> = ({
  parseObject,
  shouldExpend,
}) => {
  return (
    <StyledDiv
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <JSONTree
        theme={theme}
        hideRoot={true}
        data={parseObject}
        invertTheme={false}
        shouldExpandNodeInitially={shouldExpend}
        getItemString={(type, data, itemType, itemString, keyPath) => {
          if (type === 'Object') {
            return <span className="key-shadow">{`{...${itemString}}`}</span>;
          }
          if (type === 'Array') {
            return <span className="key-shadow">{`[...${itemString}]`}</span>;
          }
          return (
            <span>
              {itemType} {itemString}
            </span>
          );
        }}
        labelRenderer={([key]) => <strong>{key}</strong>}
      />
    </StyledDiv>
  );
};

export default TrueImpactJSON;
